import React, { useState } from "react";
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger
} from "@/components/ui/tooltip";

interface Props {
  trigger: JSX.Element;
  content: JSX.Element | string;
}

const ClickableTooltip: React.FC<Props> = ({ trigger, content }) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <Tooltip open={isOpen}>
      <TooltipTrigger asChild>
        <div
          onClick={(e) => {
            e.stopPropagation();
            setIsOpen(!isOpen);
          }}
          onMouseEnter={() => {}}
          onMouseLeave={() => {}}
        >
          {trigger}
        </div>
      </TooltipTrigger>
      <TooltipContent
        maxWidth={24}
        onPointerDownOutside={() => setIsOpen(false)}
      >
        {content}
      </TooltipContent>
    </Tooltip>
  );
};

export default ClickableTooltip;
